import { createSlice } from "@reduxjs/toolkit";
import { confirmPharmacyOrder } from "../../reducer/confirmPharmacyOrder/confirmPharmacyOrderReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const confirmPharmacyOrderSlice = createSlice({
  name: "confirmPharmacyOrder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(confirmPharmacyOrder.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(confirmPharmacyOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(confirmPharmacyOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default confirmPharmacyOrderSlice.reducer;
